// extracted by mini-css-extract-plugin
export default {"wrapper":"contest-image_wrapper__crdk4","image":"contest-image_image__8IFqu","typeTag":"contest-image_typeTag__HgseI"};